import { IsBoolean, IsNumber, IsObject, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';

export class GradeAttemptRequestDto {
  @ApiProperty({ description: 'Score obtenu', example: 14 })
  @Type(() => Number) @IsNumber() score!: number; // ex: 14

  @ApiProperty({ description: 'Score maximum', example: 20 })
  @Type(() => Number) @IsNumber() maxScore!: number; // ex: 20

  @ApiProperty({ description: 'Passé', example: true })
  @IsOptional() @IsBoolean() passed?: boolean; // si non fourni, tu pourras calculer côté front

  @ApiProperty({ description: 'Feedback', example: { message: 'Bon travail !' } })
  @IsOptional() @IsObject() feedback?: Record<string, any>;

  @ApiProperty({ description: 'Grading', example: { totalCorrect: 4, totalQuestions: 5 } })
  @IsOptional() @IsObject() grading?: Record<string, any>;

}
